import type { Role } from '@domain/entities';
import type { IRoleRepository } from '@domain/repositories';
import type { RolePayload } from '@application/dto';

export class SaveRoleUseCase {
  constructor(private readonly roleRepository: IRoleRepository) {}

  async execute(payload: RolePayload, id?: string): Promise<Role> {
    if (!id) {
      return this.roleRepository.create(payload);
    }

    // El codigo del rol es inmutable: las aplicaciones integradas lo comparan
    // literal contra sus permisos.
    return this.roleRepository.update(id, {
      name: payload.name,
      description: payload.description,
    });
  }
}
